import React from 'react';
import { Card } from '../../../components/ui/card';
import { DollarSign, X } from 'lucide-react';

export function CajaResumen({ data, isOpen = false }) {
  const total = data.efectivo + data.transferencias + data.credito + data.otros;

  return (
    <Card className="p-4">
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <DollarSign className="h-5 w-5 text-green-500" />
            <h2 className="text-lg font-semibold">Caja Actual</h2>
          </div>
          {isOpen ? (
            <div className="px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 text-sm font-medium rounded-lg">
              Abierta
            </div>
          ) : (
            <div className="px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 text-sm font-medium rounded-lg">
              Cerrada
            </div>
          )}
        </div>

        <div className="text-2xl font-bold text-gray-900 dark:text-white">
          ${total.toLocaleString()}
        </div>
        
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-500 dark:text-gray-400">Efectivo</div>
            <div className="font-medium text-gray-900 dark:text-white">${data.efectivo.toLocaleString()}</div>
          </div>
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-500 dark:text-gray-400">Transferencias</div>
            <div className="font-medium text-gray-900 dark:text-white">${data.transferencias.toLocaleString()}</div>
          </div>
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-500 dark:text-gray-400">Crédito</div>
            <div className="font-medium text-gray-900 dark:text-white">${data.credito.toLocaleString()}</div>
          </div>
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-500 dark:text-gray-400">Otros</div>
            <div className="font-medium text-gray-900 dark:text-white">${data.otros.toLocaleString()}</div>
          </div>
          
          {data.pending && data.pending.count > 0 && (
            <div className="flex justify-between items-center pt-2 border-t dark:border-gray-700">
              <div className="text-sm text-amber-500 dark:text-amber-400">Pendientes ({data.pending.count})</div>
              <div className="font-medium text-amber-500 dark:text-amber-400">${data.pending.amount.toLocaleString()}</div>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
} 